// extracted by mini-css-extract-plugin
module.exports = {"news__schema":"_9e1425b4d3--news__schema--_rc5c","news-wrap":"_9e1425b4d3--news-wrap--DUttQ","news":"_9e1425b4d3--news--P8n3v"};